import "keen-slider/keen-slider.min.css"
import React, { useState, useEffect, useCallback, useMemo } from "react"
import Skeleton from "./Skeleton/Skeleton"
import CustomImage from "./atoms/Image/CustomImage"
import { Advertisement } from "types/Advertisements"
import useDevice from "hooks/useDevice"
import Link from "next/link"

interface IProps {
    advertisements: Advertisement[]
    isLoading?: boolean
    sliderRef: any
    instanceRef: any
    currentSlide: any
    loaded: boolean
}

const HeroVTwo = React.memo(
    ({
        advertisements,
        isLoading = false,
        instanceRef,
        sliderRef,
        loaded,
        currentSlide,
    }: IProps) => {
        const { osType } = useDevice()
        const [isMounted, setIsMounted] = useState(false)
        const isIosOrMac = osType === "ios" || osType === "mac"

        const [visibleSlide, setVisibleSlide] = useState(currentSlide)

        const changeSlide = useCallback((nextSlide: number) => {
            // Start fade-out
            // setFade(false);

            // Wait for fade-out to finish, then update slide and fade-in
            const timeout = setTimeout(() => {
                setVisibleSlide(nextSlide)
                // setFade(true);
            }, 3000) // fade-out duration in ms

            return () => clearTimeout(timeout)
        }, [])

        useEffect(() => {
            const cleanup = changeSlide(currentSlide)
            return cleanup
        }, [currentSlide, changeSlide])

        // Device-specific config
        const deviceConfig = useMemo(
            () => ({
                height: isIosOrMac
                    ? "h-64 md:h-96 lg:h-screen"
                    : "aspect-video",
            }),
            [isIosOrMac]
        )

        // ✅ Always apply blur
        const blurStyle = useMemo(
            () => ({
                filter: `blur(200px)`,
                opacity: 1,
                transform: "scale(1)",
                willChange: "filter",
            }),
            []
        )

        useEffect(() => {
            setVisibleSlide(currentSlide)
        }, [currentSlide])

        const renderedImage = useMemo(() => {
            return advertisements.map((ad, index) => {
                const isVisible = index === visibleSlide
                return (
                    <CustomImage
                        key={ad._id}
                        src={`${process.env.NEXT_PUBLIC_Event_Img_URL}${ad.web_image || ""}`}
                        alt={ad.ar_description || "Advertisement"}
                        fill
                        className={`object-cover  transition-opacity duration-1000 ${
                            isVisible ? "opacity-100 z-10" : "opacity-0 z-0"
                        } absolute top-0 left-0 w-full h-full`}
                    />
                )
            })
        }, [advertisements, visibleSlide])

        const staticImages = useMemo(
            () => [
                "https://passticketscdn.azureedge.net/frontend/hero.png",
                "https://passticketscdn.azureedge.net/frontend/hero2.png",
                "https://passticketscdn.azureedge.net/frontend/Frame 1000003662.png",
            ],
            []
        )

        // const handleDotClick = useCallback((index: number) => {
        //     instanceRef.current?.moveToIdx(index)
        // }, [instanceRef])

        useEffect(() => {
            setIsMounted(true)
        }, [])

        // Render advertisement logic

        if (!loaded) {
            return <></>
        }

        if (isLoading || !isMounted) {
            return (
                <Skeleton
                    count={1}
                    type="hero_image"
                    className={`${deviceConfig.height} max-h-screen w-full overflow-hidden md:block`}
                />
            )
        }

        if (advertisements?.length === 0) {
            return (
                <div className="navigation-wrapper relative" style={blurStyle}>
                    <div ref={sliderRef} className="keen-slider">
                        {staticImages.map((image, index) => (
                            <div
                                key={index}
                                className={`keen-slider__slide relative ${deviceConfig.height} max-h-screen w-full overflow-hidden md:block number-slide${index + 1}`}
                            >
                                <CustomImage
                                    src={image}
                                    alt="hero image"
                                    style={{ objectFit: "contain" as const }}
                                    fill
                                    priority={index === 0}
                                    sizes="100vw"
                                    quality={85}
                                />
                            </div>
                        ))}
                    </div>
                    {/* {loaded && instanceRef.current && (
                    <>
                        <div className="pointer-events-none absolute bottom-0 left-1/2 flex h-full w-full -translate-x-1/2 items-end justify-center gap-2 bg-gradient-to-t from-white from-0% to-30% pb-2 dark:from-primary-theme-500" />
                        <div className="dots absolute bottom-0 left-0 flex h-5 w-full items-center justify-center gap-2 md:h-10">
                            {[...Array(instanceRef.current.track.details?.slides.length).keys()].map((idx) => (
                                <span
                                    key={idx}
                                    onClick={() => handleDotClick(idx)}
                                    className={`dot h-2 cursor-pointer rounded-full transition-all md:h-3 ${currentSlide === idx
                                        ? "active w-7 bg-primary-theme-200 dark:bg-action-theme-200 md:w-10"
                                        : "w-2 bg-gray-400 dark:bg-gray-600 md:w-3"
                                        }`}
                                />
                            ))}
                        </div>
                    </>
                )} */}
                </div>
            )
        }

        return (
            <div
                className="navigation-wrapper relative h-full w-full  "
                style={blurStyle}
            >
                {/* <div className="navigation-wrapper relative h-full w-full " style={blurStyle}> */}

                <div
                    ref={sliderRef}
                    className={` h-full bg-red-50 lg:${deviceConfig.height} sm:h-full keen-slider max-h-screen w-full overflow-hidden md:block `}
                >
                    {renderedImage}
                </div>

                {/* {loaded && instanceRef.current && advertisements.length > 1 && (
                <>
                    <div className="pointer-events-none absolute bottom-0 left-1/2 flex h-full w-full -translate-x-1/2 items-end justify-center gap-2 bg-gradient-to-t from-white from-0% to-30% pb-2 dark:from-primary-theme-500" />
                    <div className="dots absolute bottom-0 left-0 flex h-5 w-full items-center justify-center gap-2 md:h-10">
                        {[...Array(instanceRef.current.track.details?.slides.length).keys()].map((idx) => (
                            <span
                                key={idx}
                                onClick={() => handleDotClick(idx)}
                                className={`dot h-2 cursor-pointer rounded-full transition-all md:h-3 ${currentSlide === idx
                                    ? "active w-7 bg-primary-theme-200 dark:bg-action-theme-200 md:w-10"
                                    : "w-2 bg-gray-400 dark:bg-gray-600 md:w-3"
                                    }`}
                            />
                        ))}
                    </div>
                </>
            )} */}
                {advertisements.length === 1 && (
                    <>
                        <div className="pointer-events-none absolute bottom-0 left-1/2 flex h-full w-full -translate-x-1/2 items-end justify-center gap-2 bg-gradient-to-t from-white from-0% to-30% pb-2 dark:from-primary-theme-500" />
                        <div className="dots absolute bottom-0 left-0 flex h-5 w-full items-center justify-center gap-2 md:h-10" />
                    </>
                )}
            </div>
        )
    }
)

HeroVTwo.displayName = "HeroVTwo"

export default HeroVTwo
